export default __webpack_public_path__ + "static/media/img_company_header17.5e79ab5c.png";